// extracted by mini-css-extract-plugin
export default {"link":"eE-z","disabled":"fE-z"};